import { createContext } from "react";

const payAdminToDriverContext = createContext<any>(null);

export default payAdminToDriverContext;
